import { render, staticRenderFns } from "./TertiaryDecree.vue?vue&type=template&id=2c7fe0da&scoped=true"
import script from "./TertiaryDecree.vue?vue&type=script&lang=ts"
export * from "./TertiaryDecree.vue?vue&type=script&lang=ts"
import style0 from "./TertiaryDecree.vue?vue&type=style&index=0&id=2c7fe0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7fe0da",
  null
  
)

export default component.exports